import React from 'react'

export default function LastImportPeriod() {
  return (
    <div>LastImportPeriod</div>
  )
}
